import { getConfig } from '@klpkonsern/appconfig';
import { ContractManagementModuleName } from '@/routing/Routes';
import { ByggModuleName } from '@klp/bygg/config';
import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute, generateRouteParams } from '@klp/routing';
import type { User } from '@klp/user';

declare global {
    interface AppConfigParameters {
        WEBAPP_INTERCOM_APP_ID: string;
        WEBAPP_INTERCOM_ENABLE: boolean;
    }
}

// Helper functions
export const isIntercomEnabled = (): boolean =>
    getConfig('WEBAPP_INTERCOM_ENABLE', false);

export const ClientModuleName = 'client';

export const ClientRoutes = {
    moduleRoute: () => generateRoute([ClientModuleName]),
    byggView: (kundeNummer?: string, byggNummer?: string) =>
        generateRoute([
            ClientModuleName,
            kundeNummer,
            ByggModuleName,
            byggNummer,
        ]),
    byggListView: (kundeNummer?: string) =>
        generateRoute([ClientModuleName, kundeNummer, ByggModuleName]),
    contractForClientListView: (kundeNummer?: string, byggNummer?: string) =>
        generateRoute([
            ClientModuleName,
            kundeNummer,
            ContractManagementModuleName,
            byggNummer,
        ]),
    clientSelect: (returnUrl?: string) =>
        returnUrl
            ? generateRoute([ClientModuleName, 'select']).concat(
                  generateRouteParams({ returnUrl }),
              )
            : generateRoute([ClientModuleName, 'select']),
};

export const ClientAccess = (user?: User): boolean =>
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    (user && user.isAdmin) || false;

export const ClientMenuItems = [
    new SidebarMenuItem({
        route: ClientRoutes.clientSelect(),
        matchRoute: ClientRoutes.moduleRoute(),
        icon: IconName.CHANGE,
        translation: 'clientSelect.chooseClient',
        access: ClientAccess,
    }),
];
